import { FreeBetIcon } from 'src/domains/layouts/shared/assets/icons/FreeBetIcon';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { withConfig } from 'src/withConfig';
import { CheckCircleFilledIcon } from 'src/domains/layouts/shared/assets/icons/CheckCircleFilledIcon';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

const fadeInReceipt = keyframes`
    from {
        max-height: 0;
        opacity: 0;
    }
    to {
        max-height: 400px;
        opacity: 1;
    }
`;

interface BetslipReceiptWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const BetslipReceiptWrapper = withConfig(theme => styled('div', { label: 'BetslipReceiptWrapper' })<BetslipReceiptWrapperPropsType>`
    position: relative;
    animation: 0.4s ${fadeInReceipt} 1;
    background-color: ${theme.star.betSlipReceipt.bgColor};
    color: ${theme.star.betSlipReceipt.txtColor};
    height: 100%;
    padding: 16px;
    text-align: center;
    width: 100%;
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
    overflow: hidden;
`);

export const BetslipReceiptBottomEdge = withConfig(theme => styled('div', { label: 'BetslipReceiptBottomEdge' })<BetslipReceiptWrapperPropsType>`
    position: absolute;
    bottom: -12px;
    background-color: ${theme.star.betSlipReceipt.bgColor};
    height: 20px;
    width: 100%;
    border-top: 17px dotted ${theme.star.betslipGeneral.bgColor};
`);

export const BetslipReceiptHeader = withConfig(theme => styled('header', { label: 'BetslipReceiptHeader' })`
    display: flex;
    justify-content: space-between;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
`);

export const BetslipReceiptIconWrapper = styled(CheckCircleFilledIcon, { label: 'BetslipReceiptIconWrapper' })`
    display: block;
    fill: currentcolor;
    margin: 4px auto;
    width: 44px;
`;

export const BetslipReceiptGiftIconWrapper = styled(FreeBetIcon, { label: 'BetslipReceiptGiftIconWrapper' })`
    fill: currentcolor;
    margin: 0 5px 0 0;
    position: relative;
    top: 2px;
    width: 14px;
`;

export const Text = withConfig(theme => styled('p', { label: 'Text' })`
    color: ${theme.star.betSlipReceipt.txtColor};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.5;
    margin: 32px 0;
`);

export const ListWrapper = withConfig(theme => styled('ul', { label: 'ListWrapper' })`
    padding: 16px 0;
    text-align: left;
    border-top: 2px dashed ${theme.star.betSlipReceipt.bgColorSecondary};
`);

export const ListElement = withConfig(theme => styled('li', { label: 'ListElement' })`
    color: ${theme.star.betSlipReceipt.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.4;
    padding: 4px 0;
`);

export const ReceiptValue = withConfig(theme => styled('span', { label: 'ReceiptValue' })`
    float: right;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    margin-top: -3px;
`);

export const SmallText = withConfig(theme => styled('span', { label: 'SmallText' })`
    color: ${theme.star.betSlipReceipt.txtColorSecondary};
    display: block;
    font-size: ${theme.star.fontSize.xxSmall};
`);

export const BonusEngineFreeBetExcludedReturnsText = withConfig(theme => styled('div', { label: 'BonusEngineFreeBetExcludedReturnsText' })`
    margin-top: 16px;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    color: #1111117a;
    justify-self: start;
`);

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
`;